import Page from "@/components/layout/Page";
import useApi from "@/contexts/ApiContext";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import TrainingLayout from "@/components/layout/TrainingLayout";

const UiTraining = () => {
  const api = useApi();
  const { videoSlug } = useParams();

  const { data: training } = useQuery({ queryKey: ["get-all-ui-training"], queryFn: () =>
    api.trainingVideos.getAll("ui")
  });

  return (
    <Page title="UI training">
      <TrainingLayout training={training} title="UI Training" videoSlug={videoSlug} pageSlug="ui-training" />
    </Page>
  );
};

export default UiTraining;
